import {
  FlowConsumerOfConditionsSchema,
  FlowConsumerOfDocumentExtractSchema,
  FlowConsumerOfLabValuesSchema,
  FlowConsumerOfMedicationsSchema,
  FlowConsumerOfSurgicalHistoriesSchema,
} from 'flow-schema';
import { CareGapAlgorithm } from 'primary-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const CareGapAlgorithmBlockConfigSchema = z.object({
  algorithm: z.enum(CareGapAlgorithm, { message: 'Algorithm is required' }),
  payload: z.object({
    documents: FlowConsumerOfDocumentExtractSchema,
    labValues: FlowConsumerOfLabValuesSchema,
    medications: FlowConsumerOfMedicationsSchema,
    problems: FlowConsumerOfConditionsSchema,
    procedures: FlowConsumerOfSurgicalHistoriesSchema,
  }),
});
export type CareGapAlgorithmBlockConfig = z.infer<typeof CareGapAlgorithmBlockConfigSchema>;

export const CareGapAlgorithmBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CareGapAlgorithmBlock),
  config: CareGapAlgorithmBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.PatientFindings),
});
export type CareGapAlgorithmBlock = z.infer<typeof CareGapAlgorithmBlockSchema>;

interface EvidenceDataFields {
  providerName?: string;
  providerSpecialty?: string;
  location?: string;
  documentDate?: Date;
  impressionAndRecommendation?: string;
  recallDuration?: string;
  source: string;
  testName?: string;
  testDate?: string;
  testValue?: number;
  testResult?: string;
}

interface Evidence {
  problemListId: string | null;
  patientDocumentId: string | null;
  medicationListId: string | null;
  ehrInformationId: string;
  data: EvidenceDataFields;
  reviewState: string;
  rejectionReason: string | null;
  exportState: string;
}

export interface Finding {
  type: string;
  ehrInformationId: string;
  encounterId?: string | null;
  patientAdvisoryId?: string | null;
  icd10?: string | null;
  hccCode?: string | null;
  suspectText?: string | null;
  careGapType?: string | null;
  status: string;
  reviewState: string;
  reviewed?: Date | null;
  rejectionReason?: string | null;
  exportState: string;
  evidence?: Evidence[] | null;
}
